import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { AuthRoutingModule } from './auth-routing.module';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { AuthGuardService } from './auth-guard.service';
import { SharedModule } from '../shared/shared.module';
import { LoginComponent } from './login/login.component';
import { BrandProtectedLoginComponent } from './brand-protected-login/brand-protected-login.component';
import {
  MatLegacyCardModule as MatCardModule
} from '@angular/material/legacy-card';
import {
  MatLegacyInputModule as MatInputModule
} from '@angular/material/legacy-input';
import { ObserversModule } from '@angular/cdk/observers';
import { FlexLayoutModule } from '@angular/flex-layout';
import { RegisterComponent } from './register/register.component';
import { ForgotPasswordComponent } from './forgot-password/forgot-password.component';
import { BrandProtectedRegisterComponent } from './brand-protected-register/brand-protected-register.component';

@NgModule({
  declarations: [
    LoginComponent,
    BrandProtectedLoginComponent,
    BrandProtectedRegisterComponent,
    RegisterComponent,
    ForgotPasswordComponent
  ],
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    AuthRoutingModule,
    MatCardModule,
    ObserversModule,
    MatInputModule,
    FlexLayoutModule,
    SharedModule
  ],
  providers: [AuthGuardService],
  exports: [LoginComponent]
})
export class AuthModule {}
